import { C } from '../../lib/theme';
import { styles } from '../../lib/styles';
import { fmtDateTime } from '../../lib/util';
import { KYC_ITEMS } from '../../domain/constants';
import { unmetRequiredKyc } from '../../domain/kyc-progress';
import { Dialog } from '../Dialog';
import { useAppData } from '../../state/contexts/AppDataContext';
import { useUIState } from '../../state/contexts/UIStateContext';

export function AuditReportModal() {
  const { cases, caseAudit, stats } = useAppData();
  const { setModal } = useUIState();

  // Counts only entries already fetched into caseAudit (visited cases this session).
  const allEntries = cases.flatMap(c2 => (caseAudit[c2.id] ?? []).map(a => ({ ...a, caseId: c2.id, registrant: c2.registrant })));
  const caseCount = cases.length;
  // #772 — fully verified means every REQUIRED item ticked AND meeting its
  // evidence minimum (none on a grandfathered case): a tick the minimums say
  // could not stand is not verification.
  const kycComplete = cases.filter(c2 =>
    Object.entries(KYC_ITEMS).every(([key, item]) => !item.required || c2.kyc?.[key]?.verified)
    && unmetRequiredKyc(c2).length === 0).length;

  return (
    <Dialog title="Audit Readiness Report" onClose={() => setModal(null)}>
        <div style={{ fontSize: 12, color: C.textMuted, marginBottom: 16 }}>Generated: {fmtDateTime(new Date())}</div>
        <div style={{ display: 'grid', gap: 12, marginBottom: 16 }}>
          {[
            { label: 'Total cases in system', value: caseCount, ok: true },
            { label: 'KYC fully verified', value: `${kycComplete}/${caseCount}`, ok: kycComplete === caseCount },
            { label: 'Evidence records logged', value: cases.reduce((n, c2) => n + Object.values(c2.kyc).reduce((m: number, k: any) => m + (k?.evidence?.length || 0), 0), 0), ok: true },
            { label: 'Total audit trail entries', value: allEntries.length, ok: true },
            { label: 'Dual-control enforced', value: 'Yes', ok: true },
            { label: 'MFA enforcement', value: 'Keycloak realm policy', ok: true },
            { label: 'Executed agreements on file', value: cases.filter(c2 => c2.onboarding?.agreementExecuted).length + '/' + caseCount, ok: true },
            { label: 'Active IP disputes', value: stats.activeIpDisputes + stats.activeShaftDisputes, ok: stats.activeIpDisputes + stats.activeShaftDisputes === 0 },
            { label: 'Session timeout', value: '15 minutes', ok: true },
            { label: 'Role-based access control', value: 'Active — 4 roles', ok: true },
          ].map((item, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: `1px solid ${C.border}`, fontSize: 13 }}>
              <span>{item.label}</span>
              <span style={{ fontWeight: 600, color: item.ok ? C.success : C.warn }}>{String(item.value)}</span>
            </div>
          ))}
        </div>
        <button style={{ ...styles.btn, ...styles.btnGold }} onClick={() => setModal(null)}>Close</button>
    </Dialog>
  );
}
